/**
 * @generated SignedSource<<31a5d27b7c5aa1c36ed916b5e6b3c02a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SubscriptionPlatform = "android" | "browser" | "ios" | "lemon" | "%future added value";
export type AdminUsersSearchQuery$variables = {
  search: string;
};
export type AdminUsersSearchQuery$data = {
  readonly searchUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly affiliate: string | null;
        readonly affiliateStats: {
          readonly payout: number;
        } | null;
        readonly appLang: string | null;
        readonly createdBeforeSeconds: number;
        readonly deviceId: string | null;
        readonly deviceOs: string | null;
        readonly email: string | null;
        readonly flags: ReadonlyArray<{
          readonly body: string | null;
          readonly name: string;
          readonly updated: number;
          readonly value: string | null;
        }>;
        readonly id: string;
        readonly lastLoginBeforeSeconds: number;
        readonly lemonId: number | null;
        readonly name: string | null;
        readonly payouts: ReadonlyArray<{
          readonly amount: number | null;
        }>;
        readonly subscriptions: ReadonlyArray<{
          readonly family: boolean;
          readonly platform: SubscriptionPlatform;
          readonly storeId: string;
          readonly timeToExpire: number;
          readonly transactionId: string;
        }>;
        readonly timezone: string;
        readonly xps: {
          readonly currentStreak: number;
          readonly days: ReadonlyArray<{
            readonly added: number | null;
            readonly freeze: string | null;
            readonly reviewed: number | null;
            readonly streaked: boolean;
            readonly when: string;
            readonly xp: number | null;
          }>;
          readonly total: number;
        };
      } | null;
    } | null> | null;
  };
};
export type AdminUsersSearchQuery = {
  response: AdminUsersSearchQuery$data;
  variables: AdminUsersSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLang",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceOs",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBeforeSeconds",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastLoginBeforeSeconds",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "affiliate",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Xps",
  "kind": "LinkedField",
  "name": "xps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStreak",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DayXps",
      "kind": "LinkedField",
      "name": "days",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "xp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "added",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reviewed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "when",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streaked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "freeze",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Subscription",
  "kind": "LinkedField",
  "name": "subscriptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeToExpire",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "family",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "AffiliateStats",
  "kind": "LinkedField",
  "name": "affiliateStats",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payout",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lemonId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUsersSearchQuery",
    "selections": [
      {
        "alias": "searchUsers",
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "__Admin__searchUsers_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserFlags",
                    "kind": "LinkedField",
                    "name": "flags",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "payout",
                    "kind": "LinkedField",
                    "name": "payouts",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminUsersSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v23/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "searchUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserFlags",
                    "kind": "LinkedField",
                    "name": "flags",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "payout",
                    "kind": "LinkedField",
                    "name": "payouts",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v23/*: any*/),
        "filters": [
          "search"
        ],
        "handle": "connection",
        "key": "Admin__searchUsers",
        "kind": "LinkedHandle",
        "name": "searchUsers"
      }
    ]
  },
  "params": {
    "cacheID": "fcae4162a2b828e2e79827d0e08e74a1",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "searchUsers"
          ]
        }
      ]
    },
    "name": "AdminUsersSearchQuery",
    "operationKind": "query",
    "text": "query AdminUsersSearchQuery(\n  $search: String!\n) {\n  searchUsers(search: $search, first: 20) {\n    edges {\n      node {\n        id\n        email\n        name\n        timezone\n        appLang\n        deviceId\n        deviceOs\n        createdBeforeSeconds\n        lastLoginBeforeSeconds\n        affiliate\n        flags {\n          name\n          value\n          body\n          updated\n          id\n        }\n        xps {\n          total\n          currentStreak\n          days {\n            xp\n            added\n            reviewed\n            when\n            streaked\n            freeze\n          }\n        }\n        subscriptions {\n          transactionId\n          timeToExpire\n          platform\n          storeId\n          family\n        }\n        affiliateStats {\n          payout\n        }\n        payouts {\n          amount\n          id\n        }\n        lemonId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1206fa2e0e92717190fe7f74e0384e02";

export default node;
